import React from 'react';
import { Particles } from './Particles';
const painPoints: string[] = ['Despiertas cansada, como si no hubieras dormido nada.', 'Sientes que tu cuerpo grita lo que tu mente calla.', 'Vives con dolores que los médicos llaman "solo estrés".', 'Buscas una solución natural que no sea otra pastilla.'];
export function Hero() {
  return <section className="relative overflow-hidden px-5 py-12 sm:px-8 lg:py-16" style={{
    background: 'linear-gradient(160deg, #0c0c0c 0%, #2d1b4e 100%)'
  }} data-id="element-55" data-mp="4njq6ckn7zc1">
      <Particles data-id="element-56" data-mp="xbpch3rchwdz" />

      <div className="relative mx-auto max-w-4xl text-center" data-id="element-57" data-mp="xb5szim1qzxu">
        <span className="inline-block rounded-full border border-gold/50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-gold sm:text-[11px]" data-id="element-58" data-mp="sai3j1dgur5q">
          Medicina Integrativa · Cristales · Hierbas · Numerología
        </span>

        <h1 className="mt-5 font-display text-[30px] font-bold leading-[1.14] text-white sm:text-[38px] lg:text-[48px]" data-id="element-59" data-mp="3czfl7z4xc761">
          Elimina hasta 80 Tipos de Dolor Psicosomático en 7 Minutos al Día
          <span className="block text-gold" data-id="element-60" data-mp="3j9aldp7jncay">Sin Fármacos ni Experiencia Previa</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-gold sm:text-[18px]" data-id="element-61" data-mp="3o6u534n0ghaa">
          El manual práctico de autosanación energética que te enseña a leer el lenguaje de tu
          cuerpo y sanar desde la raíz — incluso si los médicos te dijeron que solo es estrés.
        </p>

        {/* Pain points — the avatar's bridge */}
        <div className="mx-auto mt-10 max-w-3xl" data-id="element-62" data-mp="358zpu8vah9jg">
          <h2 className="font-display text-[18px] font-normal italic tracking-wide text-gold/90 sm:text-[22px]" data-id="element-63" data-mp="35aueny9ollst">
            ¿Te sientes identificada con esto?
          </h2>
          <ul className="mt-5 grid gap-3 text-left sm:grid-cols-2" data-id="element-64" data-mp="2vjg6z37ktfol">
            {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-lg border border-white/10 bg-white/[0.04] px-4 py-3" data-id="element-65" data-mp="2hjyof5kviyno">
                <span aria-hidden="true" className="mt-0.5 text-[13px] text-gold" data-id="element-66" data-mp="s332p6wnmcud">
                  ✦
                </span>
                <span className="text-[14px] leading-snug text-white/85 sm:text-[15px]" data-id="element-67" data-mp="na0ap37izbga">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        {/* VSL */}
        <div className="mx-auto mt-11 max-w-3xl" data-id="element-68" data-mp="dbar95zzdixx">
          <p className="flex items-center justify-center gap-2 text-[11px] font-black uppercase tracking-[0.12em] text-white/85 sm:text-[12px]" data-id="element-69" data-mp="1azulzgc74ryf">
            <span aria-hidden="true" className="live-dot h-2.5 w-2.5 rounded-full bg-red-500" data-id="element-70" data-mp="15zzupboie0cu" />
            Mira esto antes de que el contador llegue a cero
          </p>

          <div className="mt-4 overflow-hidden rounded-xl border-2 border-gold" style={{
          boxShadow: '0 0 34px rgba(26, 74, 46, 0.85), 0 0 0 1px rgba(201,168,76,0.25)'
        }} data-id="element-71" data-mp="x0l3ub4fjnrt">
            <video className="block aspect-video w-full bg-black" src="https://res.cloudinary.com/lkfj1jku/video/upload/v1787190134/VSL_manual_Autosanacion.mp4" controls playsInline preload="metadata" data-id="element-72" data-mp="3hq23uqpg9u6o">
              Tu navegador no soporta la reproducción de video.
            </video>
          </div>
        </div>
      </div>
    </section>;
}